import { render, staticRenderFns } from "./CategoryCards.vue?vue&type=template&id=ca2e2dcc&"
import script from "./CategoryCards.vue?vue&type=script&lang=js&"
export * from "./CategoryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports